import { render, staticRenderFns } from "./SendOfferMessageAction.vue?vue&type=template&id=4f7feed6&"
import script from "./SendOfferMessageAction.vue?vue&type=script&lang=js&"
export * from "./SendOfferMessageAction.vue?vue&type=script&lang=js&"
import style0 from "./SendOfferMessageAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
